import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dsc from '../assets/images/imgs/DSC03506 copy.jpg'
import ser1 from '../assets/images/imgs/813A0299 copy.png'
import ser2 from '../assets/images/imgs/813A0299 copy 2.png'
import ser3 from '../assets/images/imgs/813A0299 copy 3.png'
import s1 from '../assets/images/bgimgs/s1.jpg'
import s2 from '../assets/images/bgimgs/s2.jpg'
import s3 from '../assets/images/bgimgs/s3.jpg'
import s4 from '../assets/images/bgimgs/s4.jpg'
import s5 from '../assets/images/bgimgs/s5.jpg'
import s6 from '../assets/images/bgimgs/s6.jpg'
import { Link } from "react-router-dom";

export default function Services() {
    const { t } = useTranslation();

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('services');
    }, [])
    return (
        <div>
            <section className="min-h-[calc(100vh-80px)] flex flex-col gap-[20px] lg:flex-row justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                <div className="flex flex-col gap-[20px]">
                    <div>
                        <h3 className="is-slideup text-xl lg:text-5xl 2xl:text-6xl font-black mb-[20px] lg:font-normal nc">{t('services_commitment')}</h3>
                        <h3 className="max-w-full lg:max-w-[500px] 2xl:max-w-[600px] text-lg lg:text-xl 2xl:text-2xl font-thin">{t('services_desc1')}</h3>
                        <h3 className="max-w-full lg:max-w-[500px] 2xl:max-w-[600px] text-lg lg:text-xl 2xl:text-2xl font-thin">{t('services_desc2')}</h3>
                    </div>
                </div>
                <div className="min-w-full lg:min-w-[600px] 2xl:min-w-[800px]">
                    <img className="w-full lg:w-[600px] 2xl:w-[800px]" src={dsc} alt="" />
                </div>
            </section>

            <section className="nc min-h-[calc(100vh-80px)] flex flex-col gap-[30px] justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                <h1 className="text-xl lg:text-5xl 2xl:text-6xl is-slideup">{t('why_choose_igt')}</h1>
                <div className="flex flex-col lg:flex-row gap-[50px] justify-center">
                    <div className="flex flex-col items-center gap-[10px]">
                        <img className="max-w-full lg:max-w-[200px]" src={ser1} alt="" />
                        <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('innovation')}</h2>
                        <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('innovation_desc')}</h3>
                    </div>
                    <div className="flex flex-col items-center gap-[10px]">
                        <img className="max-w-full lg:max-w-[200px]" src={ser2} alt="" />
                        <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('genuineness')}</h2>
                        <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('genuineness_desc')}</h3>
                    </div>
                    <div className="flex flex-col items-center gap-[10px]">
                        <img className="max-w-full lg:max-w-[200px]" src={ser3} alt="" />
                        <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('teamwork')}</h2>
                        <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('teamwork_desc')}</h3>
                    </div>
                </div>
                <div className="flex justify-center mt-[50px]">
                    <Link to='/contact' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('connect_us')}</Link>
                </div>
            </section>

            <section className="nc min-h-[calc(100vh-80px)] flex flex-col gap-[30px] justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                <h1 className="text-xl lg:text-3xl 2xl:text-6xl text-start w-full is-slideup">{t('for_partners')}</h1>
                <div className="flex flex-col lg:flex-row gap-[50px] justify-center">
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s1} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('market_implementation')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('market_desc')}</h3>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s2} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('retail_development')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('retail_desc_long')}</h3>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s3} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('brand_support')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('brand_support_desc')}</h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className="nc min-h-[calc(100vh-80px)] flex flex-col gap-[30px] justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                <h1 className="text-xl lg:text-3xl 2xl:text-6xl text-start w-full is-slideup">{t('for_customers')}</h1>
                <div className="flex flex-col lg:flex-row gap-[50px] justify-center">
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s4} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('pre_post_sale')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('pre_post_desc')}</h3>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s5} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('quality_reliability')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('quality_desc_long')}</h3>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[10px] w-full lg:w-1/3 border-[.5px] border-[#d0a645] rounded-[20px] overflow-hidden">
                        <img className="block" src={s6} alt="" />
                        <div className="p-[20px] flex flex-col gap-[10px]">
                            <h2 className="text-xl lg:text-2xl 2xl:text-3xl">{t('market_partnership')}</h2>
                            <h3 className="max-w-full lg:max-w-[300px] text-justify">{t('partnership_desc')}</h3>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}